import { render, staticRenderFns } from "./CorporateIdentity.vue?vue&type=template&id=02dbc0f6&"
import script from "./CorporateIdentity.vue?vue&type=script&lang=js&"
export * from "./CorporateIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports